import React, { useEffect, useState } from "react";
import PageLayout from "../../components/PageLayout";
import TextQuestion from "../../components/TextQuestion";
import Action from "../../components/Action";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Card from "../../components/Card";
import ErrorMessage from "../../components/ErrorMessage";
import LinkSent from "./LinkSent";

function Login(props) {
  const [emailAddress, setEmailAddress] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [loginSent, setLoginSent] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [emailNoMatch, setEmailNoMatch] = useState(false);

  // Search engines index this page (see NoindexUnlessPublicPage in router.go),
  // so it needs a title that says what it is: every page otherwise shows
  // index.html's "Juno".
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Sign in to your Juno dashboard";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  const resetLoginState = () => {
    setLoginSent(false);
    setEmailNoMatch(false);
    setEmailError(false);
    setEmailAddress("");
  };

  const handleEmailValidation = (event) => {
    if (event.type === "blur" && emailAddress.trim() === "") {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const validate = () => {
    let formIsValid = true;

    if (emailAddress.trim() === "") {
      setEmailError(true);
      formIsValid = false;
    }

    return formIsValid;
  };

  const submit = () => {
    if (!validate()) {
      return;
    }
    fetch(`/api/login`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email_address: emailAddress.trim(),
      }),
    })
      .then((res) => {
        if (res.ok || res.status === 403) {
          return res.json();
        }
        throw new Error("Error response from backend");
      })
      .then((data) => {
        if (data.status === "success") {
          setLoginSent(true);
        } else if (data.status === "no_match") {
          setEmailNoMatch(true);
        }
      })
      .catch((err) => {
        setLoginError(true);
      });
  };

  if (loginSent) {
    return (
      <PageLayout pageWidth="narrow">
        <LinkSent emailAddress={emailAddress} resetLoginState={resetLoginState} />
      </PageLayout>
    );
  }

  if (loginError) {
    return (
      <PageLayout pageWidth="narrow">
        <ScrollToTop />
        <Card title="Sorry, that didn’t work" removeTopPadding headingSize="2">
          <p>We couldn't log you in right now - there might be a problem with your internet connection.</p>
          <Action small onClick={() => setLoginError(false)}>
            Take me back to try again
          </Action>
        </Card>
      </PageLayout>
    );
  }

  let loginErrorText;
  if (emailNoMatch) {
    loginErrorText = (
      <ErrorMessage loginError={true}>
        The email address you supplied does not match our records. Please check you have typed it correctly.
      </ErrorMessage>
    );
  }

  return (
    <PageLayout pageWidth="narrow">
      <ScrollToTop />
      <Card title="Sign in to your Juno dashboard" removeTopPadding headingSize="1">
        {loginErrorText}

        <TextQuestion
          question="Email address"
          value={emailAddress}
          valueEntered={setEmailAddress}
          validate={handleEmailValidation}
          validationError={emailError ? "Please enter an email address" : null}
        />

        <Action small onClick={submit}>
          Email me a link to sign in instantly
        </Action>
      </Card>
    </PageLayout>
  );
}

export default Login;
